import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBigbasketComponent } from './simple-icons-bigbasket.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBigbasketComponent ],
    exports:      [ SimpleIconsBigbasketComponent ],
    bootstrap:    []
})
export class SimpleIconsBigbasketModule {}
